const KeenSlider = window.KeenSlider

class ProductCardGallery extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onGridSwitcherChange = this.onGridSwitcherChange.bind(this)
    this.listeners.add(window, 'grid-switcher:change', this.onGridSwitcherChange)
  }

  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
    this.queueSlideHint()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return
    if (this.els.slide.elements.length < 2) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        rubberBand: false,
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            drag: false,
            initial: 1,
            renderMode: 'custom',
            defaultAnimation: {
              duration: 500,
            },
            detailsChanged: (slider) => {
              slider.slides.forEach((element, index) => {
                element.style.opacity = slider.track.details.slides[index].portion
              })
            },
          },
        },
      },
      [
        window.BAO.Carousel.plugins.setInitialised(),
        window.BAO.Carousel.plugins.useDots(this.els?.dot?.elements),
        window.BAO.Carousel.plugins.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  onGridSwitcherChange () {
    requestAnimationFrame(() => {
      this.restartCarousel()
      this.carousel = this.setupCarousel()
      this.queueSlideHint()
    })
  }

  isDesktop () {
    return window.matchMedia('(min-width: 768px)').matches
  }

  queueSlideHint () {
    if (!this.carousel || this.hasPlayedHint) return
    if (this.isDesktop()) return
    if (!this.isSlideHintEnabled()) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    if (!this.isFirstGalleryInGrid()) return

    this.onHintDrag = () => {
      window.clearTimeout(this.hintTimer)
      this.hasPlayedHint = true
    }
    this.carousel.on('dragStarted', this.onHintDrag)

    this.hintTimer = window.setTimeout(() => {
      this.playSlideHint()
    }, 1000)
  }

  playSlideHint () {
    const details = this.carousel?.track?.details

    if (!details || details.maxIdx < 1 || details.rel !== 0) return

    this.hasPlayedHint = true

    const peekDistance = details.slides[0].size * 0.3
    const easeOut = (progress) => 1 - Math.pow(1 - progress, 3)

    this.carousel.animator.start([
      {
        distance: peekDistance,
        duration: 500,
        easing: easeOut,
      },
      {
        distance: 0,
        duration: 200,
        easing: easeOut,
      },
      {
        distance: peekDistance * -1,
        duration: 500,
        easing: easeOut,
      },
    ])
  }

  isSlideHintEnabled () {
    const grid = this.closest('[data-product-card-slide-hint]')

    if (!grid) return true

    return grid.getAttribute('data-product-card-slide-hint') === 'true'
  }

  isFirstGalleryInGrid () {
    const grid = this.closest('.prd-List_Items') || this.closest('.collection-products')

    if (!grid) return false

    return grid.querySelector('product-card-gallery') === this
  }

  restartCarousel () {
    window.clearTimeout(this.hintTimer)

    if (this.carousel?.destroy) {
      this.carousel.destroy()
    }
    this.carousel = null

    if (this.els.slides?.element) {
      this.els.slides.element.removeAttribute('data-initialised')
    }
  }

  disconnectedCallback () {
    this.restartCarousel()
    super.disconnectedCallback()
  }
}

if (!customElements.get('product-card-gallery')) {
  customElements.define('product-card-gallery', ProductCardGallery)
}
